<template>
  <template v-if="Array.isArray(menuSubs) && menuSubs.length">
    <ul
      ref="submenuRef"
      class="max-h-0 overflow-hidden duration-500 transition-all"
      :style="switchHeightStyle"
    >
      <li v-for="menuSub in menuSubs" :key="menuSub.id">
        <div
          @click="externalOrInternalLink(menuSub.url, menuSub.open)"
          :class="`
          flex items-center pl-8 py-2 pr-4
          ${validateUrl(menuSub.url) ? 'cursor-pointer hover:bg-gray-200' : ''}
          ${menuSub.url === currentUrl ? 'bg-blue-200': ''}
          `"
        >
          <div class="flex items-center">
            <base-svg-icon class="w-5 mr-2" :path="menuSub.icon" />
            <div class="flex items-center text-gray-700">
              <div class="w-40 sm:w-52 truncate font-light">{{ menuSub.title }}</div>
              <template v-if="validateUrl(menuSub.url) === LINK_STATUS.external">
                <base-svg-icon class="w-4" :path="mdiOpenInNew" />
              </template>
            </div>
          </div>
        </div>
      </li>
    </ul>
  </template>
</template>

<script lang="ts">
import { defineComponent, ref, computed, PropType } from 'vue'

import { mdiOpenInNew } from '@mdi/js'
import BaseSvgIcon from '@/components/BaseSvgIcon.vue'
import { MenuSubAttributes } from '@/types/models/menu-sub'
import { validateUrl, externalOrInternalLink, LINK_STATUS } from '@/router/utils'
import { useRoute } from 'vue-router'

export default defineComponent({
  components: { BaseSvgIcon },
  props: {
    menuSubs: {
      type: Array as PropType<MenuSubAttributes[] | undefined>,
      'default': () => ([]),
    },
    isOpen: {
      type: Boolean,
      'default': () => (true),
    },
  },
  setup(props) {
    const route = useRoute()
    const submenuRef = ref<HTMLElement | undefined>(undefined)

    const switchHeightStyle = computed(() => {
      return props.isOpen ? `max-height: ${submenuRef.value?.scrollHeight}px` : ''
    })

    const currentUrl = computed(() => {
      return `${route.path}${window.location.search}`
    })

    return {
      switchHeightStyle,
      submenuRef,
      validateUrl,
      externalOrInternalLink,
      mdiOpenInNew,
      LINK_STATUS,
      currentUrl
    }
  },
})
</script>
